import { render, staticRenderFns } from "./DirectoryBanners.vue?vue&type=template&id=88731ae0&scoped=true"
import script from "./DirectoryBanners.vue?vue&type=script&lang=js"
export * from "./DirectoryBanners.vue?vue&type=script&lang=js"
import style0 from "./DirectoryBanners.vue?vue&type=style&index=0&id=88731ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88731ae0",
  null
  
)

export default component.exports